// extracted by mini-css-extract-plugin
export default {"tokenDroprateGrid":"tokens_tokenDroprateGrid__JgUbk"};